export const wineListIs = {
  hero: {
    title: 'Vínseðill',
    subtitle: 'Vandað úrval af einstökum ítalskum vínum',
  },
  description:
    'Vínseðillinn okkar inniheldur vandlega úrval vína frá bestu svæðum Ítalíu, með áherslu á smærri fjölskylduvíngerðir sem stunda sjálfbæra vínrækt.',
  subCategories: {
    'Soda & juices': 'Gosdrykkir og safar',
    'Draft beer': 'Bjór á krana',
    'Bottled beer': 'Flöskubjór',
    Cocktails: 'Kokteilar',
    Coffee: 'Kaffi',
    Liquors: 'Líkjörar',
    Snaps: 'Snaps',
    'Alcoholic Coffee drinks': 'Kaffidrykkir með áfengi',
  },
  pairing: {
    title: 'Tillögur að vínpörun',
    description:
      'Starfsfólk okkar er alltaf tilbúið að mæla með fullkominni vínpörun við matinn þinn. Ekki hika við að spyrja þjóninn þinn um tillögur!',
    categories: [
      {
        title: 'Með pizzu',
        description: 'Chianti Superiore, Valpolicella, eða hreint Pinot Grigio',
      },
      {
        title: 'Með pasta',
        description: 'Amarone með ríkum kjötsósum, Soave með sjávarréttapasta',
      },
      {
        title: 'Með eftirréttur',
        description: 'Prosecco með ávaxta eftirréttur, Tosti Rosé með súkkulaði',
      },
    ],
  },
  categories: {
    white: 'Hvítvín',
    rose: 'Rósavín',
    sparkling: 'Freyðivín',
    champagne: 'Kampavín',
    red: 'Rauðvín',
    beverages: 'Drykkir',
  },
  items: {
    1: {
      name: 'Frescobaldi, Attems Chardonnay',
      region: 'Ítalía – Venezia Giulia',
      description:
        'Mikil og skemmtileg fylling, sameinar ávaxtakeim af hvítum fíkjum, quince, mandarínu, keim af ristuðu brauði, furuhnetum og kryddaðri vanillu. Vínið er mjúkt með löngu ávaxtaríku eftirbragði.',
    },
    2: {
      name: 'Frescobaldi, Rémole Bianco',
      region: 'Ítalía – Toscana IGT',
      description:
        'Vermentino & Trebbiano, fersk blanda sem einkennist af blómum, gulum eplum, melónu og stjörnuávöxt.',
    },
    3: {
      name: 'Van Gogh Riesling',
      region: 'Þýskaland – Mosel',
      description: 'Ferskur Riesling sem ber með sér bragð af grænum eplum, apríkósum og ferskjum.',
    },
    4: {
      name: 'Las Moras Sauvignon Blanc',
      region: 'Argentína - San Juan',
      description:
        'Ferskir ávaxtatónar af greipaldin og með hint af aspas, þurrt með ferskum sítrus.',
    },
    5: {
      name: 'Allegrini Soave D.O.C.',
      region: 'Ítalía – Veneto',
      description: 'Ferskir ávöxtur, jasmín og sítrus, þurrt með ferskum sítrus.',
    },
    6: {
      name: 'Villa Lucia Pinot Grigio',
      region: '',
      description: 'Lifandi og bragðgott með góðan ávöxt. Allt sem gott vín þarf að hafa.',
    },
    7: {
      name: 'Faustino VII',
      region: 'Spánn',
      description:
        'Öflugur angan af jarðaberjum og brómberjum, ávaxtaríkt og ferskt í munni með skemmtilegum Temranillo áhrifum.',
    },
    8: {
      name: 'Frescobaldi, Tenuta Ammiraglia Alíe',
      region: 'Ítalía – Toscana',
      description:
        'Fallega ljósbleikt og silkimjúkt með ávaxtakeim af ferskju, hvítum ávöxt, arómatískum jurtum og sítrus.',
    },
    9: {
      name: 'Tosti Prosecco Rosé',
      region: 'Ítalía – Piedmonte',
      description: 'Þurr fíngerð freyðing, fersk sýra með ávöxt, hindber, blóm og eplahýði.',
    },
    10: {
      name: 'Tosti Prosecco',
      region: 'Ítalía – Piedmonte',
      description: 'Fögult. Ósætt, létt freyðing, fersk sýra. Ljós ávöxtur, eplakjarni.',
    },
    11: {
      name: 'Bollinger Special Cuveé',
      region: 'Frakkland – Champagne',
      description:
        'Ljósgullið. Góð fylling, þurrt og ferskt með breiðan ilm, kakó, sítrusávöxt, epli og ferskjur auk hýðis- og gertóna.',
    },
    12: {
      name: 'Chianti Superiore Poggie Al Casone',
      region: 'Ítalía – Toscana',
      description:
        'Rúbín rautt með blóma og kirsuberjailm. Milt eftirbragð með kirsuberjum og mildri eik.',
    },
    13: {
      name: 'Tenuta Frescobaldi Castiglioni',
      region: 'Ítalía – Toscana IGT',
      description: 'Cabernet Sauvignon, Merlot, Cabernet Franc og Sangiovese.',
    },
    14: {
      name: 'Allegrini Valpolicella Classico',
      region: 'Ítalía – Veneto D.O.C.',
      description: 'Ferstk með kirsuberjum og kryddjurtu, þurrt flauelsmjúkt.',
    },
    15: {
      name: 'Louis Latour Bourgogne Rouge Cuvée Latour',
      region: 'Frakkland – Bourgogne',
      description: 'Pinot Noir með kirsuber, jarðaber og þurru eftirbragði',
    },
    16: {
      name: 'Amarone Della Valpolicella',
      region: 'Ítalía – Veneto D.O.C.G.',
      description:
        'Kröftugir tónar af þroskuðum dökkum ávöxt, öflugur í munni og silkimjúkt tannín.',
    },
    17: {
      name: 'Las Moras Black Label Malbec',
      region: 'Argentía – San Juan',
      description:
        'Djúpur ávöxtur af þroskuðum plómum, ristuðu kaffi og súkkulaði. Mjúkt tannin og létt eik.',
    },
    18: {
      name: 'Baffo Rosso Chianti',
      region: '',
      description: 'Þurr Chianti, létt tannín með ferskum óþroskuðum skógarberjum.',
    },
  },
};
